import { Button, LoadingIcon } from '@kalos/ui';
import { type FC } from 'react';

export const LoadMoreButton: FC<{
  onClick: () => void;
  isLoading: boolean;
}> = ({ onClick, isLoading }) => (
  <div className="flex justify-center pt-2">
    <Button type="button" variant="outline" size="sm" onClick={onClick} disabled={isLoading}>
      {isLoading ? (
        <>
          <LoadingIcon className="mr-2 h-4 w-4" />
          Loading...
        </>
      ) : (
        'Load More'
      )}
    </Button>
  </div>
);

/** Expands a collapsed list (showing the first few rows) to reveal the rest. */
export const ShowMoreButton: FC<{
  remaining: number;
  onClick: () => void;
}> = ({ remaining, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="w-full rounded-md bg-blue-50 py-2.5 text-xs font-medium text-blue-600 transition-colors hover:bg-blue-100"
  >
    Show more ({remaining})
  </button>
);

/** Collapses an expanded list back to the first few rows. */
export const ShowLessButton: FC<{
  onClick: () => void;
}> = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="w-full rounded-md bg-blue-50 py-2.5 text-xs font-medium text-blue-600 transition-colors hover:bg-blue-100"
  >
    Show less
  </button>
);
